<ll-titulo>{{ "evaluacion.compartidas.historial" | t }}</ll-titulo>

<evaluaciones-multiples-compartidas-alumno
    *ngIf="tipoInstrumento"
    [evaluacionTipo]="tipoInstrumento"
></evaluaciones-multiples-compartidas-alumno>
